import * as React from "react";

interface NotFoundProps {
  message?: string;
}

const NotFound: React.FC<NotFoundProps> = () => <div>404 not found</div>;

export default NotFound;
